module.exports = __webpack_public_path__ + "static/media/fabric_logo_lg.dbe5af38.png";